import axios from 'axios'

const WithdrawalService = {
  async get (params = {}) {
    return axios.get('prd/withdrawal/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/withdrawal/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('prd/exports/withdrawal/receivings', { params })
  },

  async show (id) {
    return axios.get(`prd/withdrawal/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/withdrawal/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/withdrawal/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/withdrawal/receivings/${data.id}`, { data })
  }
}

export default WithdrawalService
